import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EntryHistoryTable from '../common/EntryHistoryTable';
import EditInwardWeightModal from './EditInwardWeightModal';
import { API_BASE_URL } from '../../config';
import './InwardEntry.css';

const InwardEntryHistory = ({ showCreatedBy = false, showPONumber = true }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/inward-entries`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEntries(response.data);
      setLoading(false);
    } catch (err) {
      setError('Error fetching entries');
      setLoading(false);
    }
  };

  const handleTimeoutUpdate = async (id) => {
    try {
      setError('');
      setSuccess('');
      const token = localStorage.getItem('token');
      
      // Get current time in IST format
      const now = new Date();
      const time_out = now.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Asia/Kolkata'
      });
      
      await axios.patch(
        `${API_BASE_URL}/api/inward-entries/${id}/timeout`,
        { time_out },
        { headers: { Authorization: `Bearer ${token}` }}
      );

      // Update the entry in the local state
      setEntries(entries.map(entry => 
        entry.id === id ? { ...entry, time_out } : entry
      ));
      setSuccess('Time out updated successfully');
    } catch (err) {
      console.error('Error updating timeout:', err);
      setError(err.response?.data?.message || 'Error updating timeout');
    }
  };

  // Handler for edit button click
  const handleEditClick = (entry) => {
    setSelectedEntry(entry);
    setEditModalOpen(true);
  };

  // Handler for modal close
  const handleModalClose = () => {
    setEditModalOpen(false);
    setSelectedEntry(null);
  };

  // Handler for modal save (update weights)
  const handleModalSave = async (updatedFields) => {
    // Update the entry in the local state with new weights and timeout
    setEntries(entries.map(entry =>
      entry.id === selectedEntry.id
        ? { ...entry, ...updatedFields }
        : entry
    ));
    handleModalClose();
  };

  if (loading) return <div className="loading">Loading entries...</div>;

  return (
    <div className="inward-entry-history">
      <h2>Inward Entry History</h2>
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
      <EntryHistoryTable 
        entries={entries}
        onTimeoutUpdate={handleTimeoutUpdate}
        type="inward"
        showCreatedBy={showCreatedBy}
        showActions={true}
        onEdit={handleEditClick}
      />
      {editModalOpen && (
        <EditInwardWeightModal
          isOpen={editModalOpen}
          entry={selectedEntry}
          onClose={handleModalClose}
          onSave={handleModalSave}
        />
      )}
    </div>
  );
};

export default InwardEntryHistory;
